module.exports = __webpack_public_path__ + "img/empty-search.a6b46d7.gif";